import { ReactNode } from 'react'

export type TabLayoutProps = {
  children?: ReactNode
}

export function TabLayout({ children  }: TabLayoutProps) {

  return (
    <div className="w-full flex justify-center">
      <div className="flex flex-col gap-6 w-full max-w-6xl">
        { children }
      </div>
    </div>
  )
}
